import React from 'react';
import { Box, Flex } from '@mantine/core';
import DynamicNonFinancialDataFields from './DynamicNonFinancialDataFields';

export default function DeprecatedNonFinancialDataContent() {
  return (
    <Flex direction={'row'} justify={'stretch'}>
      <Box flex={1}>
        <DynamicNonFinancialDataFields />
      </Box>
    </Flex>
  );
}
